import { render, staticRenderFns } from "./GoalCard.vue?vue&type=template&id=25508b54&"
import script from "./GoalCard.vue?vue&type=script&lang=js&"
export * from "./GoalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports